import React from 'react';
import styles from './Question.module.scss';
import {HomeQuestions as features} from "application/globals/home-data";
import QuestionItem from "./components/QuestionItem/QuestionItem";

export const Question = (props) => {
  return (
    <>
      <div className="pt-6 lg:pt-8" id="question-section"/>
      <div className={styles.container}>
        <h1>¿Tienes preguntas?</h1>
        <h3>Te orientamos en las principales dudas o preguntas que puedes tener.</h3>
        {
          features.map(feature => <QuestionItem {...feature} key={feature.title}/>)
        }
      </div>
    </>
  );
};

Question.propTypes = {}

Question.defaultProps = {}

export default React.memo(Question);
